<template>
    <div class="container px-2">
        <Carousel
            :scrollPerPage="false"
            :perPageCustom="slideConfiguration"
            :paginationEnabled="false"
            :navigationEnabled="true"
            :navigationPrevLabel="prevLabel"
            :navigationNextLabel="nextLabel"
        >
            <Slide v-for="(slide, i) in slides" :key="i">

                <div class="md:pr-2 h-full" data-aos="fade-up" :data-aos-delay="`${(i + 1) * 100}`">
                    <div class="bg-white p-3 text-center border-box h-full">

                        <div>
                            <img v-if="slide.carousel_image" class="bg-grey-3" :src="slide.carousel_image['sizes']['medium']" :alt="`image relating to ${slide.carousel_title}`">
                        </div>

                        <p class="template-h3 mt-3 capitalize font-400">
                            <a v-if="slide.carousel_link" class="text-black-2" :href="slide.carousel_link">{{ slide.carousel_title }}</a>
                            <span v-if="!slide.carousel_link" class="text-black-2" >{{ slide.carousel_title}}</span>
                        </p>

                        <div class="mt-3 break-normal text-grey-2 font-300 leading-normal" v-html="slide.carousel_description"></div>

                        <div class="mt-3" v-if="slide.carousel_link">
                            <a class="view-more text-white text-white-hover bg-blue hover-primary rounded text-sm leading-loose" :href="slide.carousel_link">
                                <div>View more</div>
                            </a>
                        </div>

                    </div>
                </div>

            </Slide>
        </Carousel>
    </div>
</template>

<script>
    // Import the entire module instead of destructuring
    import { Carousel, Slide } from 'vue-carousel';

    export default {

        name: 'CarouselSquares',

        components: {
            Carousel,
            Slide
        },

        props: {
            slides: {
                type: Array,
                default() {
                    return [];
                },
            },
        },

        computed: {
            prevLabel() {
                return "<span class='text-6'>&lsaquo;</span>";
            },

            nextLabel() {
                return "<span class='text-6'>&rsaquo;</span>";
            },

            slideConfiguration() {
                let big = 4,
                    medium = 3,
                    small = 2,
                    tiny = 1;

                if (this.slides.length < big) {
                    big = this.slides.length;
                } else if (this.slides.length < medium) {
                    medium = this.slides.length;
                } else if (this.slides.length < small) {
                    small = this.slides.length;
                } else if (this.slides.length < tiny) {
                    tiny = this.slides.length;
                }

                return [[100, tiny], [480, small], [768, medium], [1200, big]];
            },

        },

    }

</script>

<style>
    .VueCarousel-navigation--disabled {
        display: none;
    }

    @media (max-width: 420px) {
        .VueCarousel-navigation {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/CarouselSquares.vue